import Cookies from "js-cookie";
import { isLiveBuild } from "./AppUrl";
import { beginNewAuthSession, getAuthSessionId, parseAuthJwt } from "./authSession";

const DEFAULT_PROJECT_ID = "yjoenwedud";
let scriptLoaded = false;

const getProjectId = () =>
	process.env.REACT_APP_CLARITY_PROJECT_ID || DEFAULT_PROJECT_ID;

const clarityCall = (...args) => {
	if (typeof window === "undefined") return;
	window.clarity =
		window.clarity ||
		function () {
			(window.clarity.q = window.clarity.q || []).push(arguments);
		};
	window.clarity(...args);
};

export const loadClarityScript = (projectId) => {
	if (typeof document === "undefined" || scriptLoaded) return;
	scriptLoaded = true;
	const t = document.createElement("script");
	t.async = true;
	t.defer = true;
	t.src = `https://www.clarity.ms/tag/${projectId}`;
	document.body.appendChild(t);
};

export const initClarity = () => {
	if (!isLiveBuild || typeof window === "undefined") return;
	loadClarityScript(getProjectId());
};

export const syncClarityIdentity = () => {
	if (!isLiveBuild || typeof window === "undefined") return;
	const token = Cookies.get("_cb_search_token");
	if (!token) return;

	const auth = parseAuthJwt(token);
	if (!auth?.email || auth.userId == null) return;

	loadClarityScript(getProjectId());

	const sessionId = getAuthSessionId(auth.userId);
	const role = auth.universalPasswordLogin ? "admin" : "user";

	clarityCall("identify", auth.email, sessionId, null, auth.email);
	clarityCall("set", "userRole", role);
	clarityCall("set", "userId", String(auth.userId));
};

/** Call after setting auth cookie on login / signup. */
export const onAuthLoginSuccess = (userId) => {
	if (userId == null) {
		const token = Cookies.get("_cb_search_token");
		const auth = parseAuthJwt(token);
		userId = auth?.userId;
	}
	if (userId == null) return;
	beginNewAuthSession(userId);
	syncClarityIdentity();
};
